import { useEffect } from "react";
import { useMutation } from "react-query";
import moment from "moment";

import { deleteUserExperience } from "../../../apis/private.api";
import { IUserWorkingExperience } from "../../../constants/app.dto";

import { useIdToText } from "../../../hooks/IdToText";
import { useUser } from "../../../hooks/User";

import { InfoText } from "../../info_text";
import { ToggleableCardWrapper } from "../ToggleableCardWrapper";

import { textChooser } from "../../../util/textChooser";

import { InformationList } from "./styled";

export interface CardWorkExperienceProps extends IUserWorkingExperience { }

export const CardWorkExperience = (props: CardWorkExperienceProps) => {
  const { getDataByAttributeName, setDataByAttributeName } = useUser();
  const { converIdToText } = useIdToText();

  const workExperience = getDataByAttributeName("workExperience");

  const { isSuccess, isError, isLoading, mutate } = useMutation((param: any) =>
    deleteUserExperience(param.uid, param.xid)
  );

  const handleDeleteExperience = (uid: string, xid: string) => {
    mutate({ uid, xid });
  }

  const renderExperienceDate = ({finishAt, startAt}: any) => {
    let year = moment(finishAt ? finishAt : moment.now()).diff(startAt, 'year');
    return `${year} ${textChooser('txt26')}${year === 1 ? '' : 's'}`;
  }

  useEffect(() => {
    if (isSuccess) {
      const updatedWorkEx = workExperience.filter((f: IUserWorkingExperience) => f.id !== props.id);
      setDataByAttributeName("workExperience", updatedWorkEx);
    }
  }, [isSuccess]);

  return (
    <ToggleableCardWrapper
      handleDelete={() => handleDeleteExperience(props.customer_id, props.id)}
      isDeleting={isLoading}
    >
      <InformationList>
        <li>
          {textChooser("txt219")}:
          <span> {props.jobName}</span>
        </li>
        <li>
          {textChooser("txt103")}:
          <span> {converIdToText(props.hierarchy, 'positions')}</span>
        </li>
        <li>
          {textChooser("txt104")}:
          <span> {converIdToText(props.sector, 'sectors')}</span>
        </li>
        <li>
          {textChooser("txt102")}:
          <span> {converIdToText(props.field, 'areas')}</span>
        </li>
        <li>
          {!props?.finishAt ? (
            <>
              {moment((new Date(props.startAt))).format('DD/MM/YYYY')}{(' - ')}
              {textChooser("txt179")}
            </>
          ) : (
            <>
              {textChooser("txt192")}: <span>{renderExperienceDate(props)}</span>
            </>
          )}
        </li>
        {props.nameContactReference && props.cellPhoneContactReference && props.emailContactReference &&
          <>
            <hr />
            <li>
              {textChooser("txt221")}:
              <span> {props.nameContactReference}</span>
            </li>
            <li>
              {textChooser("txt223")}:
              <span> {props.cellPhoneContactReference}</span>
            </li>
            <li>{textChooser("txt225")}:
              <span> {props.emailContactReference}</span>
            </li>
          </>
        }
      </InformationList>
      <InfoText text={textChooser("txt141")} type="danger" hidden={!isError} />
    </ToggleableCardWrapper >
  )
}